export default __webpack_public_path__ + "static/Calibre-RegularItalic-57371b9e514dbbe9da31dad1a298de2d.woff";